import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { fetchWithAuth } from "../../utils/fetchWithAuth";

const API_BASE = (
  process.env.REACT_APP_API_URL || "http://localhost:5000"
).replace(/\/+$/, "");

export default function NotificationsPage() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchNotifications = async () => {
    try {
      setLoading(true);
      const res = await fetchWithAuth(`${API_BASE}/api/admin/notifications`);
      if (!res.ok) throw new Error("Impossible de charger les notifications");

      const data = await res.json();
      setNotifications(data.notifications || []);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const markAsRead = async (id) => {
    try {
      const res = await fetchWithAuth(
        `${API_BASE}/api/admin/notifications/${id}/read`,
        {
          method: "PATCH",
        },
      );

      if (!res.ok) throw new Error("Erreur lors de la mise à jour");

      setNotifications((prev) =>
        prev.map((n) => (n.id === id ? { ...n, isRead: true } : n)),
      );
    } catch (err) {
      toast.error(err.message);
    }
  };

  const deleteNotification = async (id) => {
    try {
      const res = await fetchWithAuth(
        `${API_BASE}/api/admin/notifications/${id}`,
        {
          method: "DELETE",
        },
      );

      if (!res.ok) throw new Error("Erreur lors de la suppression");

      setNotifications((prev) => prev.filter((n) => n.id !== id));
      toast.success("Notification supprimée");
    } catch (err) {
      toast.error(err.message);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  return (
    <div className="p-4">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-white">
          Notifications
        </h1>
        <p className="text-sm text-slate-500">
          Alertes administratives, transactions et événements système.
        </p>
      </div>

      {loading ? (
        <p>Chargement...</p>
      ) : notifications.length === 0 ? (
        <div className="rounded-xl border bg-white dark:bg-slate-900 p-6 text-slate-500">
          Aucune notification.
        </div>
      ) : (
        <div className="space-y-3">
          {notifications.map((n) => (
            <div
              key={n.id}
              className={`rounded-xl border p-4 bg-white dark:bg-slate-900 ${
                n.isRead ? "opacity-70" : "border-yellow-400"
              }`}
            >
              <div className="flex justify-between gap-4">
                <div>
                  <h3 className="font-semibold text-slate-900 dark:text-white">
                    {n.title}
                  </h3>
                  <p className="text-sm text-slate-600 dark:text-slate-300 mt-1">
                    {n.message}
                  </p>
                  <p className="text-xs text-slate-400 mt-2">
                    {new Date(n.createdAt).toLocaleString()}
                  </p>
                </div>

                <div className="flex gap-2">
                  {!n.isRead && (
                    <button
                      onClick={() => markAsRead(n.id)}
                      className="px-3 py-1 text-xs rounded bg-green-600 text-white"
                    >
                      Lu
                    </button>
                  )}

                  <button
                    onClick={() => deleteNotification(n.id)}
                    className="px-3 py-1 text-xs rounded bg-red-600 text-white"
                  >
                    Supprimer
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
